import React, { useState, useEffect, useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import styled from "@emotion/styled";
import './enrollment.css';
import { toast } from 'react-toastify';
import axios from 'axios'
import enrollmentService from '../../features/enrollment/enrollmentService';
import authService from '../../features/auth/authService';
import Spinner from '../Layout/Spinner';
import _ from 'lodash';
import pdfService from '../../features/pdf/pdfService';
import { Link } from 'react-router-dom';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Fab from '@mui/material/Fab';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LinearProgress from '@mui/material/LinearProgress';

import Tooltip from '@mui/material/Tooltip';


import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as us from 'underscore';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const TableRowStyled = styled(TableRow)`
  &:nth-of-type(even) {
    background-color: #EEEEEE;
  }
`;

function Enrollment(props) {

  let [isLoading, setIsLoading] = useState(false);
  const [enrollmentdata, setEnrollmentData] = useState([]);
  let [showSubmit, setShowSubmit] = useState(false);
  const [initEnrollmentdata, setInitEnrollmentdata] = useState([]);
  let [entollmentInitData, setEntollmentInitData] = useState([]);
  let [entollmentfileData, setentollmentfileData] = useState([]);
  let [entollmentcompareData, setentollmentcompareData] = useState([]);
  let [saveShow, setSaveShow] = useState(false);
  const [distName, setDistName] = useState('');

  useEffect(() => {
    document.title = props.title

    setIsLoading(true);
    enrollmentService.getEnrollmentPageDate({ districtId: authService.getDist(), academicyear:localStorage.getItem("academicyear") }).then((response) => {
      setInitEnrollmentdata([...response.data.enrollmentPageData])
      setentollmentcompareData(transformData(response.data));
      setEnrollmentData(response.data.enrollmentPageData);
      setDistName(response.data.distName)
      setEntollmentInitData(_.cloneDeep(response.data.enrollmentPageData))
      setIsLoading(false);
      setShowSubmit(true);
      setSaveShow(true);
      const schoolIds = new Set();
      response.data.enrollmentPageData.forEach(page => {
            page.schoolEnrollData.forEach(school => {
                schoolIds.add(school.schoolId);
            });
        });
      const schoolIdList = Array.from(schoolIds);
      console.log("schoolIdList",schoolIdList)
      setentollmentfileData(schoolIdList)
      if (response.data.enrollmentPageData.length == 0) {
        setSaveShow(false);
        setShowSubmit(false);
        toast.warning('Enrollment data are only required for the student surveys. At least one student survey must be selected to enter enrollments.')
      }
    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
      setIsLoading(false);
    })
  }, []);


  const handleSave = () => {

    if (_.isEqual(enrollmentdata, initEnrollmentdata)) {
      toast.warn("Trying to save data without any change.")
    } else {
      console.log("enrollmentdata : " + enrollmentdata);
      setIsLoading(true);
      enrollmentService.saveEnrollmentPageData({ districtId: authService.getDist(), enrollmentData: enrollmentdata }).then((response) => {
        toast.success(response.data.message ? response.data.message : "Error in submiting the data");
        setIsLoading(false);
        setSaveShow(false)
      
        setTimeout(() => {
          window.location.reload();
      }, 7000);
      }).catch(err => {
        toast.error(err.message ? err.message : "Error in submiting the data");
        setIsLoading(false);
      })
    }
  };

  const handleFinish = () => {
    toast.info("Thank you for providing enrollment")
    setSaveShow(true)
  }

  const updateEnrollment = (pageId, schoolId, enrollmentId, value) => {
    console.log("value : ", value)
    if (/^\d*$/.test(value)) {
      const newEnrollmentData = enrollmentdata.map((pageData) =>
        pageData._id === pageId
          ? {
            ...pageData,
            schoolEnrollData: pageData.schoolEnrollData.map((schoolData) =>
              schoolData.schoolId === schoolId
                ? {
                  ...schoolData,
                  enrollmentData: schoolData.enrollmentData.map((enrollmentData) =>
                    enrollmentData.enrollmentId === enrollmentId
                      ? { ...enrollmentData, value: value }
                      : enrollmentData
                  ),
                }
                : schoolData
            ),
          }
          : pageData
      );

      setEnrollmentData(newEnrollmentData);
    }
  };

  const resetSelection = (event) => {
    event.stopPropagation();
    let name = event.target.getAttribute('name');

    let initEnrollObj = initEnrollmentdata.find((val, key) => {
      return val.shortCode == name
    })

    let filterEnrlList = enrollmentdata.map((val, key) => {
      return val.shortCode == name ? initEnrollObj : val
    })

    setEnrollmentData(filterEnrlList);
  }

  let urlDistName = (distName.replace("%20", " ")).replace(/ /g, '');

  /* PDF Generation **START */
  /* Generate PDF for Enrollment */
  const onpdfdownload = () => {
    let hdrImage = "data:image/png;base64,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";
    let doc = new jsPDF('l');

    doc.addImage(hdrImage, 'PNG', 14, 14, 30, 8, 'logo');
    doc.setFontSize(14);
    doc.setTextColor(143, 149, 151);
    doc.text(14, 28, 'CalSCHLS Coordinator Portal');

    doc.setFontSize(12);
    doc.setTextColor(248, 119, 28);
    doc.text(14, 35, distName);

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(14, 42, 'STUDENT ENROLLMENTS');
    /* doc.text('ENROLLMENT DETAILS', 15, 35);
    doc.setFontSize(10); */
    doc.setTextColor(0, 60, 104);
    doc.autoTable({
      startY: 44,
      tableLineColor: [231, 76, 60],
      styles: {
        lineColor: 240,
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [0, 60, 104],
        textColor: 240,
        fontSize: 6,
        fontStyle: 'bold',
        halign: 'center'
      },
      bodyStyles: {
        textColor: [0, 60, 104],
        fontSize: 8
      },
      body: createJSONforPDF(),
      columns: [
        { header: 'SURVEY TYPE', dataKey: 'surveyNm' },
        { header: 'SCHOOL NAME', dataKey: 'sn' },
        { header: 'SCHOOL ID', dataKey: 'sid' },
        { header: 'E-3', dataKey: 'e3' },
        { header: 'E-4', dataKey: 'e4' },
        { header: 'E-5', dataKey: 'e5' },
        { header: 'E-6', dataKey: 'e6' },
        { header: 'E-7', dataKey: 'e7' },
        { header: 'E-8', dataKey: 'e8' },
        { header: 'E-9', dataKey: 'e9' },
        { header: 'E-10', dataKey: 'e10' },
        { header: 'E-11', dataKey: 'e11' },
        { header: 'E-12', dataKey: 'e12' },
        { header: 'NT', dataKey: 'NT' },
      ],
    });
    doc.save(pdfFileName(urlDistName));
  }

  const getEnrollData = (shortCode, schoolId, enrollmentName) => {
    let surveyData = enrollmentdata.find((val, key) => {
      return val.shortCode == shortCode
    });

    if (surveyData) {
      let findSchool = surveyData.schoolEnrollData.find((val, key) => {
        return val.schoolId == schoolId
      });

      if (findSchool) {

        let findEnroll = findSchool.enrollmentData.find((val, key) => {
          return val.enrollmentName == enrollmentName
        });

        if (findEnroll) {
          return findEnroll.value ? findEnroll.value : '';
        } else {
          return ''
        }

      } else {
        return ''
      }
    } else {
      return ''
    }
  }
  /* Create JSON object for PDF */
  const createJSONforPDF = () => {
    let output = [];
    enrollmentdata.map(enrolData => {
      enrolData.schoolEnrollData.map(enrolDet => {
        console.log("shortCode ---- " + enrolDet.shortCode);
        console.log("schoolId ---- " + enrolData.schoolId);

        let jsonObj = us.pick(enrolDet, 'sn', 'sid', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'e10', 'e11', 'e12', 'NT');
        jsonObj['surveyNm'] = enrolData.name;
        jsonObj['sn'] = enrolDet.name;
        jsonObj['sid'] = enrolDet.ncesId;
        jsonObj['e3'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "3rd");
        jsonObj['e4'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "4th");
        jsonObj['e5'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "5th");
        jsonObj['e6'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "6th");
        jsonObj['e7'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "7th");
        jsonObj['e8'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "8th");
        jsonObj['e9'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "9th");
        jsonObj['e10'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "10th");
        jsonObj['e11'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "11th");
        jsonObj['e12'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "12th");
        jsonObj['NT'] = getEnrollData(enrolData.shortCode, enrolDet.schoolId, "NT");
        output.push(jsonObj);
      });
    });
    return output;
  }

  const pdfFileName = (urlDistName) => {
    let today = new Date();
    try {
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0!
      // let hoursMint = `${today.getHours()}${today.getMinutes()}`;
      let hoursMint = `${String(today.getHours()).padStart(2, '0')}${String(today.getMinutes()).padStart(2, '0')}`;

      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = `Enrollment_${urlDistName.replace(/\s+|\\|\//g, "")}_${yyyy}${mm}${dd}${hoursMint}.pdf`;
    } catch (error) {
      console.log(`ERROR: ${error}, in pdfFileName().`);
    }
    return today;
  }
  /* PDF Generation **END */

  /* Excel upload enhancement - START */
  const fileInputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const createExcelFromJson = async (jsonData) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Enrollment Data');
  
    const headers = [
      { header: 'object_id', key: 'object_id', width: 30},
      { header: 'County', key: 'county', width: 20 },
      { header: 'District', key: 'district', width: 20 },
      { header: 'School Name', key: 'schoolname', width: 25 },
      { header: 'School ID', key: 'schoolId', width: 25 },
      { header: 'Grade Served', key: 'gradeServed', width: 15 }
    ];
  
    const hasElementarySurvey = jsonData.enrollmentPageData.some(survey => survey.name === 'Elementary Survey');
    const hasMiddleSchoolSurvey = jsonData.enrollmentPageData.some(survey => survey.name === 'Middle School Survey');
    const hasHighSchoolSurvey = jsonData.enrollmentPageData.some(survey => survey.name === 'High School Survey');
  
    if (hasElementarySurvey) {
      headers.push(
        { header: 'Elementary Survey 3rd', key: 'elementary3rd', width: 25 },
        { header: 'Elementary Survey 4th', key: 'elementary4th', width: 25 },
        { header: 'Elementary Survey 5th', key: 'elementary5th', width: 25 },
        { header: 'Elementary Survey 6th', key: 'elementary6th', width: 25 }
      );
    }
    if (hasMiddleSchoolSurvey) {
      headers.push(
        { header: 'Middle School Survey 6th', key: 'middle6th', width: 25 },
        { header: 'Middle School Survey 7th', key: 'middle7th', width: 25 },
        { header: 'Middle School Survey 8th', key: 'middle8th', width: 25 }
      );
    }
    if (hasHighSchoolSurvey) {
      headers.push(
        { header: 'High School Survey 9th', key: 'high9th', width: 25 },
        { header: 'High School Survey 10th', key: 'high10th', width: 25 },
        { header: 'High School Survey 11th', key: 'high11th', width: 25 },
        { header: 'High School Survey 12th', key: 'high12th', width: 25 },
        { header: 'High School Survey NT', key: 'highNT', width: 25 }
      );
    }
    headers.push({ header: 'Export Date', key: 'exportDate', width: 15 });
    worksheet.columns = headers;
  
    const date = new Date();
    const offset = -7 * 60; // PST is UTC-8
    const utcTimestamp = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
    const pstTimestamp = utcTimestamp + (offset * 60 * 1000);
    const pstdate = new Date(pstTimestamp);
  
    // const currentDate = `${pstdate.getMonth() + 1}-${pstdate.getDate()}-${pstdate.getFullYear()}`;
    const month = String(pstdate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(pstdate.getDate()).padStart(2, '0');
      const year = pstdate.getFullYear();

      const currentDate = `${month}-${day}-${year}`;
    const schoolRows = new Map();
    jsonData.enrollmentPageData.forEach(survey => {
      survey.schoolEnrollData.forEach(school => {
        let rowData = schoolRows.get(school.schoolId);
  
        if (!rowData) {
          rowData = {
            object_id:school.schoolId,
            county: jsonData.countyName,
            district: jsonData.distName,
            schoolname: school.name,
            schoolId: school.ncesId,
            gradeServed: school.grade,
            exportDate: currentDate
          };
          schoolRows.set(school.schoolId, rowData);
        }
  
        school.enrollmentData.forEach(enrollment => {
          const value = enrollment.value || 0;
          
          if (survey.name === 'Elementary Survey') {
            if (enrollment.enrollmentName === '3rd') rowData.elementary3rd = value;
            else if (enrollment.enrollmentName === '4th') rowData.elementary4th = value;
            else if (enrollment.enrollmentName === '5th') rowData.elementary5th = value;
            else if (enrollment.enrollmentName === '6th') rowData.elementary6th = value;
          } else if (survey.name === 'Middle School Survey') {
            if (enrollment.enrollmentName === '6th') rowData.middle6th = value;
            else if (enrollment.enrollmentName === '7th') rowData.middle7th = value;
            else if (enrollment.enrollmentName === '8th') rowData.middle8th = value;
          } else if (survey.name === 'High School Survey') {
            if (enrollment.enrollmentName === '9th') rowData.high9th = value;
            else if (enrollment.enrollmentName === '10th') rowData.high10th = value;
            else if (enrollment.enrollmentName === '11th') rowData.high11th = value;
            else if (enrollment.enrollmentName === '12th') rowData.high12th = value;
            else if (enrollment.enrollmentName === 'NT') rowData.highNT = value;
          }
        });
      });
    });
  
    schoolRows.forEach(rowData => {
      worksheet.addRow(rowData);
    });
  
    const headerRow = worksheet.getRow(1).values;
    const rowsData = [];
    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber !== 1) {
            rowsData.push(row.values);
        }
    });
    rowsData.sort((a, b) => {
      if (a[4] === 'n/a' || b[4] === 'n/a') {
          return a[4] === 'n/a' ? 1 : -1;
      }
      return (a[4] || '').localeCompare(b[4] || '');
  });

    while (worksheet.rowCount > 1) {
      worksheet.spliceRows(2, 1);
  }
  // Add header row back
  // worksheet.addRow(headerRow);

  // Add sorted rowsData back to the worksheet
  rowsData.forEach(rowData => worksheet.addRow(rowData));
  worksheet.getColumn(1).hidden = true;
    // Add dotted border to header row
    

    headers.forEach((header, index) => {
      let fillColor = null;
      if (header.header.startsWith('Elementary Survey')) {
        fillColor = 'B2FFFF';
      } else if (header.header.startsWith('Middle School Survey')) {
        fillColor = 'B5CAE8';
      } else if (header.header.startsWith('High School Survey')) {
        fillColor = 'ffd7b5';
      }
  
      worksheet.getColumn(index + 1).eachCell({ includeEmpty: true }, (cell) => {
        if (fillColor) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: fillColor }
          };
        }
        cell.border = {
          top: { style: 'dotted' },
          left: { style: 'dotted' },
          bottom: { style: 'dotted' },
          right: { style: 'dotted' }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });
    worksheet.getRow(1).eachCell((cell) => {
      cell.border = {
        top: { style: 'dotted' },
        left: { style: 'dotted' },
        bottom: { style: 'medium' },
        right: { style: 'dotted' }
      };
    });

  
    const rows = worksheet.getColumn(1);
    const rowsCount = rows['_worksheet']['_rows'].length;
  
    for (let i = 0; i < rowsCount + 1; i++) {
      worksheet.getRow(i).protection = { locked: false, lockText: false };
    }
  
    for (let i = 2; i < rowsCount + 1; i++) { // Start from 2 to exclude the header row
      worksheet.getRow(i).getCell(1).alignment = { horizontal: 'left' };
      worksheet.getRow(i).getCell(2).alignment = { horizontal: 'left' };
      worksheet.getRow(i).getCell(3).alignment = { horizontal: 'left' };
      worksheet.getRow(i).getCell(4).alignment = { horizontal: 'left' };
      worksheet.getRow(i).getCell(5).alignment = { horizontal: 'left' };
    }
  
    worksheet.getColumn('A').protection = { locked: true, lockText: true };
    worksheet.getColumn('B').protection = { locked: true, lockText: true };
    worksheet.getColumn('C').protection = { locked: true, lockText: true };
    worksheet.getColumn('D').protection = { locked: true, lockText: true };
    worksheet.getColumn('E').protection = { locked: true, lockText: true };
  
    let lastColumn = 1;
  
    worksheet.eachRow((row) => {
      row.eachCell((cell, colNumber) => {
        if (cell.value && colNumber > lastColumn) {
          lastColumn = colNumber;
        }
      });
    });
    worksheet.getColumn(lastColumn).eachCell((cell) => { cell.protection = { locked: true, lockText: true }; });
  
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 6 && colNumber <= lastColumn) {
          console.log(cell.value)
          if(cell.value===null){
            cell.protection = { locked: true, lockText: true };
          }
          
        }
      });
    });
    let temp;
    let letter = '';
    while (lastColumn > 0) {
      temp = (lastColumn - 1) % 26;
      letter = String.fromCharCode(temp + 65) + letter;
      lastColumn = (lastColumn - temp - 1) / 26;
    }
  
    worksheet.autoFilter = {
      from: 'E1',
      to: `E1`
    };
  
    worksheet.getRow(1).protection = { locked: true, lockText: true };
    const startColumn = 7; // G is the 7th column
    const totalColumns = worksheet.columns.length;

    for (let col = startColumn; col <= totalColumns; col++) {
        worksheet.getColumn(col).eachCell({ includeEmpty: true }, (cell) => {
            cell.dataValidation = {
                type: 'whole',
                operator: 'greaterThanOrEqual',
                formula1: '0',
                showErrorMessage: true,
                errorTitle: 'Invalid Input',
                error: 'Only integer values are allowed.',
                errorStyle: 'stop'
            };
        });
    }
    await worksheet.protect('Pass@123', {
      selectLockedCells: true,
      selectUnlockedCells: true,
      formatCells: true,
      formatColumns: true,
      formatRows: true,
      sort: true, // Enable sorting
      autoFilter: true,
      insertRows: true,
      deleteRows: true,
      insertColumns: true,
      deleteColumns: true,
      insertHyperlinks: true
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buf]), excelFileName(urlDistName, localStorage.getItem('lastName')));
  };

  const excelFileName = (urlDistName, dcLastName) => {
    let today = new Date();
    try {
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let hoursMint = `${String(today.getHours()).padStart(2, '0')}${String(today.getMinutes()).padStart(2, '0')}`;

      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = `Enrollment_${urlDistName.replace(/\s+|\\|\//g, "")}_${dcLastName.replace(/\s+|\\|\//g, "")}_${yyyy}${mm}${dd}${hoursMint}.xlsx`;
    } catch (error) {
      console.log(`ERROR: ${error}, in pdfFileName().`);
    }
    return today;
  }

  const transformDataToJSON = (excelData) => {
    const surveys = {
      'Elementary Survey': ['3rd', '4th', '5th', '6th'],
      'Middle School Survey': ['6th', '7th', '8th'],
      'High School Survey': ['9th', '10th', '11th', '12th', 'NT']
    };

    const enrollmentdata=[
      ['3rd','Elementary Survey','6475cb242cca0dd5e7fbdd8f'],
      ['4th','Elementary Survey','6475cb3b2cca0dd5e7fbdd92'],['5th','Elementary Survey','6475cb462cca0dd5e7fbdd95'],['6th','Elementary Survey','6475cb502cca0dd5e7fbdd98'],['6th','Middle School Survey','649e6513a729d8d96623a859'],['7th','Middle School Survey','6475cc352cca0dd5e7fbdd9e'],['8th','Middle School Survey','6475cc3f2cca0dd5e7fbdda1'],['9th','High School Survey','6475cc572cca0dd5e7fbdda4'],['10th','High School Survey','6475cc612cca0dd5e7fbdda7'],['11th','High School Survey','6475cc6f2cca0dd5e7fbddaa'],['12th','High School Survey','6475cc792cca0dd5e7fbddad'],['NT','High School Survey','6475cc832cca0dd5e7fbddb0']]
    const firstObject = excelData[0];
    const result = {
      distName: firstObject.County,
      countyName: firstObject.District,
      enrollmentPageData: []
    };

    const schoolDataMap = new Map();
    excelData.forEach(item => {
      /* ADDED NEWLY - START */
      const ncesIdToFind = item['School ID'];
      let schoolobjectid = null;
      
      for (const survey of initEnrollmentdata) {
        for (const schoolEnrollData of survey.schoolEnrollData) {
          if (schoolEnrollData.ncesId === ncesIdToFind) {
            schoolobjectid = schoolEnrollData.schoolId;
            break;
          }
        }
        if (schoolobjectid) break;
      }

      /* ADDED NEWLY - END */

      const schoolId = item['School ID'];
      if (!schoolDataMap.has(schoolId)) {
        schoolDataMap.set(schoolId, {
          name: item['School Name'],
          // schoolId: item['School ID'],
          schoolId:schoolobjectid,
          ncesId: item['School ID'],
          grade: item['Grade Served'],
          enrollmentData: {}
        });
      }

      const school = schoolDataMap.get(schoolId);

      Object.keys(surveys).forEach(surveyName => {
        surveys[surveyName].forEach(grade => {
          const key = `${surveyName} ${grade}`;
          if (item[key] !== undefined && item[key] !== null) {
            if (!school.enrollmentData[surveyName]) {
              school.enrollmentData[surveyName] = [];
            }

            let enrollmentId = '';
            for (let i = 0; i < enrollmentdata.length; i++) {
              if (enrollmentdata[i][0] === grade && enrollmentdata[i][1] === surveyName) {
                enrollmentId = enrollmentdata[i][2];
              }
            }

            school.enrollmentData[surveyName].push({
              enrollmentId: enrollmentId,
              enrollmentName: grade,
              value: item[key]
            });
          }
        });
      });
    });

    schoolDataMap.forEach((schoolData, schoolId) => {
      Object.keys(schoolData.enrollmentData).forEach(surveyName => {
        let survey = result.enrollmentPageData.find(s => s.name === surveyName);
        if (!survey) {
          let shortcode = '';
          if (surveyName === 'Elementary Survey') {
            shortcode = 'es';
          } else if (surveyName === 'Middle School Survey') {
            shortcode = 'ms';
          } else if (surveyName === 'High School Survey') {
            shortcode = 'hs';
          }

          let idfiled = '';
          if (surveyName === 'Elementary Survey') {
            idfiled = '6448b627c643b3788308e3f0';
          } else if (surveyName === 'Middle School Survey') {
            idfiled = '6448b627c643b3788308e3f1';
          } else if (surveyName === 'High School Survey') {
            idfiled = '6448b627c643b3788308e3f4';
          }

          survey = { _id: idfiled, name: surveyName, shortCode: shortcode, schoolEnrollData: [] };
          result.enrollmentPageData.push(survey);
        }
        survey.schoolEnrollData.push({
          name: schoolData.name,
          ncesId: schoolData.ncesId,
          schoolId:schoolData.schoolId,
          grade: schoolData.grade,
          enrollmentData: schoolData.enrollmentData[surveyName]
        });
      });
    });

    result.enrollmentPageData.forEach(survey => {
      survey.schoolEnrollData.sort((a, b) => a.name.localeCompare(b.name));
  });
    return result;
  };
  function updateOldDataWithNewData(oldData, newData) {
    const newDataMap = new Map(newData.map(item => [item["School ID"], item]));
    function updateFields(oldItem, newItem) {
        const updatedItem = { ...oldItem };
        const keysToUpdate = Object.keys(newItem).filter(key =>
            key.startsWith('Elementary') || key.startsWith('High') || key.startsWith('Middle')
        );
        keysToUpdate.forEach(key => {
          // updatedItem[key] = newItem[key];
          const newValue = newItem[key];
          if (Number.isInteger(newValue) && /^[0-9]+$/.test(newValue.toString())) {
              updatedItem[key] = newValue;
          }
        });
        updatedItem["Export Date"] = newItem["Export Date"];
        return updatedItem;
    }
    const updatedData = oldData.map(oldItem => {
        const newItem = newDataMap.get(oldItem["School ID"]);
        if (newItem) {
            return updateFields(oldItem, newItem);
        }
        return oldItem;
    });
    return updatedData;
}

  const handleFileUpload = () => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json1 = XLSX.utils.sheet_to_json(worksheet);
        console.log("json1",json1)
        console.log("entollmentcompareData",entollmentcompareData)
        const json = updateOldDataWithNewData(entollmentcompareData, json1);
        console.log("json",json)
        // logic for enrollment enhancemenet issue start here
        const combineSurveys = (data) => {
          const combinedData = {};

          data.forEach(survey => {
            const surveyName = survey.name;

            survey.schoolEnrollData.forEach(school => {
              const { ncesId, name } = school;
              const enrollmentData = school.enrollmentData;

              if (!combinedData[ncesId]) {
                combinedData[ncesId] = {
                  County: "zOut of State",
                  District: "Survey Testing 10",
                  "School Name": name,
                  "School ID": ncesId,
                  "Grade Served": "K-12",
                  "Export Date": new Date().toLocaleDateString("en-US")
                };
              }

              enrollmentData.forEach(entry => {
                const grade = entry.enrollmentName;
                const key = `${surveyName} ${grade}`;
                combinedData[ncesId][key] = (combinedData[ncesId][key] || 0) + 0;
              });
            });
          });

          return Object.values(combinedData);
        };

        const result = combineSurveys(enrollmentdata);
        const newDataMap = new Map(json.map(item => [item["School ID"], item]));
        result.forEach(mainItem => {
          const schoolId = mainItem["School ID"];
          if (newDataMap.has(schoolId)) {
            const newItem = newDataMap.get(schoolId);
            Object.keys(mainItem).forEach(key => {
              if (newItem[key] !== undefined) {
                mainItem[key] = newItem[key];
              }
            });
          }
        });
        const data1Map = new Map();
        result.forEach(item => {
          data1Map.set(item["School Name"], item);
        });
        const mergedData = json.map(item => {
          const schoolData = data1Map.get(item["School Name"]) || {};
          return {
            ...item,
            ...Object.keys(schoolData).reduce((acc, key) => {
              if (!(key in item)) {
                acc[key] = schoolData[key];
              }
              return acc;
            }, {})
          };
        });
        const schoolNamesInData2 = new Set(json.map(item => item["School Name"]));
        const additionalEntries = [...data1Map.values()].filter(item => !schoolNamesInData2.has(item["School Name"]));

        const finalData = [...mergedData, ...additionalEntries];
        const transformedData = transformDataToJSON(finalData);
        // logic for enrollment enhancemenet issue end here
        console.log("transformeddata", transformedData);
        if (transformedData) {
          setOpen(false);
          setFile(null);
          setUploadProgress(0);
          toast.success('Enrollment excel file is uploaded successfully')
          console.log("transformedData :" + transformedData)
          setEnrollmentData(transformedData.enrollmentPageData);
          console.log("****************************** transformedData START ");
          console.log(transformedData.enrollmentPageData);
          console.log("*** transformedData END ***************************");
        }
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFile(null);
    setUploadProgress(0);
  };

  const handleFileSelect = () => {
    fileInputRef.current.click();
  };
  function arraysMatch(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();
    for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
            return false;
        }
    }
    return true;
}
const createNameToLengthMap = data => 
  data.reduce((map, { name, schoolEnrollData }) => {
      map[name] = schoolEnrollData.length;
      return map;
  }, {});

const lengthsMatch = (map1, map2) =>
  Object.keys(map1).every(name => map1[name] === map2[name]) &&
  Object.keys(map2).every(name => map2[name] === map1[name]);


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
      const validExtensions = ['xlsx', 'xls'];
      const matchDistrict = (selectedFile.name).includes(urlDistName.replace(/\s+|\\|\//g, ""));
      console.log("matchDistrict :", matchDistrict);
      if (!validExtensions.includes(fileExtension) || !matchDistrict) {
        toast.error('Invalid file. Please upload correct file.');
        setFile(null);
        setUploadProgress(0);
      } else {
        const reader = new FileReader();
        reader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        const transformedData = transformDataToJSON(json);
        const objectIds = json.map(item => item.object_id);
        const data1Map = createNameToLengthMap(transformedData.enrollmentPageData);
        const data2Map = createNameToLengthMap(enrollmentdata);
        const comparisonResult = lengthsMatch(data1Map, data2Map) ? "Length is matching" : "Length is not matching";
        if(comparisonResult==="Length is not matching"){
          toast.error('Invalid file. Please upload correct file.');
          setFile(null);
          setUploadProgress(0);
        }
        else if (arraysMatch(entollmentfileData, objectIds)) {
          simulateUpload(selectedFile);
      } else {
        toast.error('Invalid file. Please upload correct file.');
        setFile(null);
        setUploadProgress(0);
      }
      }
      reader.readAsBinaryString(selectedFile);
        
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      const fileExtension = droppedFile.name.split('.').pop().toLowerCase();
      const validExtensions = ['xlsx', 'xls'];
      const matchDistrict = (droppedFile.name).includes(urlDistName.replace(/\s+|\\|\//g, ""));
      console.log("matchDistrict :", matchDistrict);
      if (!validExtensions.includes(fileExtension) || !matchDistrict) {
        toast.error('Invalid file. Please upload correct file.');
        setFile(null);
        setUploadProgress(0);
      } else {
        simulateUpload(droppedFile);
      }
    }
    // setFile(droppedFile);

  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const simulateUpload = (file) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress === 100) {
        clearInterval(interval);
        toast.success('The file is ready to upload. Click "Upload" to proceed.');
        // setSaveShow(true)
        setFile(file);
      }
    }, 500);
  };


// function transformData(rawData) {
//     const date = new Date();
//     const offset = -7 * 60;
//     const utcTimestamp = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
//     const pstTimestamp = utcTimestamp + (offset * 60 * 1000);
//     const pstDate = new Date(pstTimestamp);
//     const exportDate = `${pstDate.getMonth() + 1}-${pstDate.getDate()}-${pstDate.getFullYear()}`;
//     const countyName = rawData.countyName;
//     const distName = rawData.distName;

//     return rawData.enrollmentPageData.flatMap(survey => 
//         survey.schoolEnrollData.map(school => {
//             const base = {
//                 "object_id": school.schoolId,
//                 "County": countyName,
//                 "District": distName,
//                 "School Name": school.name,
//                 "School ID": school.ncesId,
//                 "Grade Served": school.grade,
//                 "Export Date": exportDate
//             };

//             const enrollmentFields = school.enrollmentData.reduce((acc, enrollment) => {
//                 acc[`${survey.name} ${enrollment.enrollmentName}`] = 0;
//                 return acc;
//             }, {});

//             return { ...base, ...enrollmentFields };
//         })
//     );
// }

function transformData(rawData) {
  const date = new Date();
  const offset = -7 * 60;
  const utcTimestamp = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
  const pstTimestamp = utcTimestamp + (offset * 60 * 1000);
  const pstDate = new Date(pstTimestamp);
  const exportDate = `${pstDate.getMonth() + 1}-${pstDate.getDate()}-${pstDate.getFullYear()}`;
  const countyName = rawData.countyName;
  const distName = rawData.distName;
  const schoolMap = new Map();
  rawData.enrollmentPageData.forEach(survey => {
      survey.schoolEnrollData.forEach(school => {
          const schoolId = school.schoolId;
          const base = {
              "object_id": school.schoolId,
              "County": countyName,
              "District": distName,
              "School Name": school.name,
              "School ID": school.ncesId,
              "Grade Served": school.grade,
              "Export Date": exportDate
          };
          if (!schoolMap.has(schoolId)) {
              schoolMap.set(schoolId, { ...base });
          }
          const currentEntry = schoolMap.get(schoolId);
          school.enrollmentData.forEach(enrollment => {
              const key = `${survey.name} ${enrollment.enrollmentName}`;
              currentEntry[key] = (currentEntry[key] || 0) + 0;
          });
      });
  });
  return Array.from(schoolMap.values());
}


  const onExcelTemplatedownload = () => {
    setIsLoading(true);
    enrollmentService.getEnrollmentPageDateExcel({ districtId: authService.getDist() }).then((response) => {
      setIsLoading(false);
      createExcelFromJson(response.data)
      setentollmentcompareData(transformData(response.data));
      if (response.data.enrollmentPageData.length == 0) {
        toast.warning('Enrollment data are only required for the student surveys. At least one student survey must be selected to enter enrollments.')
      }
    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
      setIsLoading(false);
    })
  }
  /* Excel upload enhancement - END */

  return (
    <>
      {localStorage.getItem("academicyear") === 'currentyear' && (
      <>
      {isLoading === true ? <Spinner /> : null}
      <div className="marquee-container">
        <div className="marquee-content">
          <p>If you would like to upload enrollments using an Excel file with prepopulated schools, please contact your TA.</p>
        </div>
      </div>
      </>
      )}
      <div className='survey_pageHeader'>
        <div className="surveyDateTab">
          <div style={{ width: authService.getRole() !== 'admin' ? '96%' : '86%' }} className="pageText">Student Enrollments</div>
          {authService.getRole() === 'admin' && localStorage.getItem("academicyear") === 'currentyear' ? (
            <div className="flexContainer">
              <Tooltip title='Download enrollments' placement="top-start">
                <div className='enrol_addDashUser'>
                  <span>
                    <Fab size="small" color="primary" aria-label="add" className='enrol_downloadFile' onClick={onExcelTemplatedownload}>
                      <FileDownloadOutlinedIcon />
                    </Fab>
                  </span>
                </div>
              </Tooltip>
              <Tooltip title='Upload enrollments' placement="top-start">
                <div className='enrol_addDashUser'>
                  <input type="file" id="fileUpload" style={{ display: 'none' }} ref={fileInputRef}
                    onChange={handleFileChange} />
                  <span>
                    <Fab size="small" color="primary" aria-label="add" className='enrol_downloadFile'
                      onClick={handleClickOpen}>
                      <FileUploadOutlinedIcon />
                    </Fab>
                  </span>
                </div>
              </Tooltip>
              {/* <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
              <DialogTitle>Upload File</DialogTitle>
              <DialogContent>
                 <div className="drag-drop-area" onClick={handleFileSelect}>
                  <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <p style={{ margin: 0 }}>Click to select a file</p>
                    <span style={{ marginLeft: '10px', marginTop: '2px' }}>
                      <FileUploadIcon />
                    </span>
                  </div>
                  {file && <p>Selected file: {file.name}</p>}
                </div>
                <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
                {uploadProgress > 0 && (
                  <div style={{ marginTop: '20px' }}>
                    <LinearProgress variant="determinate" value={uploadProgress} sx={{borderRadius:'4px'}}/>
                    <p>{uploadProgress}%</p>
                  </div>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleFileUpload} color="primary" disabled={!file} className="mDist_save_button">Upload</Button>
                <Button onClick={handleClose} color="primary" className="mDist_cancel_button">Cancel</Button>
              </DialogActions>
            </Dialog> */}

              <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Upload File</DialogTitle>
                <DialogContent>
                  {file ? (
                    <div>
                      <p>Selected file: {file.name}</p>
                    </div>
                  ) :
                    (
                      <div
                        className="drag-drop-area"
                        onClick={handleFileSelect}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        style={{ border: '2px dashed #ccc', padding: '20px', textAlign: 'center' }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: 'center' }}>
                          <p style={{ margin: 0 }}>Click to select a file or drag and drop it to upload.</p>
                          <span style={{ marginLeft: '10px', marginTop: '0px' }}>
                            <FileUploadIcon />
                          </span>
                        </div>
                      </div>
                    )}
                  {/* {file && <p style={{ marginTop: '10px' }}>Selected file: {file.name}</p>} */}
                  <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
                  {uploadProgress > 0 && (
                    <div>
                      <LinearProgress variant="determinate" value={uploadProgress} sx={{ borderRadius: '4px', marginTop: '5px' }} />
                      <p style={{ marginTop: '5px', fontSize: '14px' }}>{uploadProgress}%</p>
                    </div>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleFileUpload} color="primary" disabled={!file} className="mDist_save_button">Upload</Button>
                  <Button onClick={handleClose} color="primary" className="mDist_cancel_button">Cancel</Button>
                </DialogActions>
              </Dialog>
              </div>
            ) : null}

          <Button onClick={onpdfdownload}>
            <img className='pdfImage' src={require('../../assets/images/downloadpdf.png')} alt='Download Pdf'></img>
          </Button>
        </div>
      </div>

      <div className='pageContent'>
        {enrollmentdata.map((pageData) => (
          <Accordion key={pageData._id}>
            <AccordionSummary
              className='accSumm'
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{ flexDirection: 'row-reverse', padding: '16.5px 0 2px 15px' }}
              key={pageData._id}
            >
              <Table className='accordionHeader_enrollment'>
                <TableRow>
                  <TableCell className='schoolHeader_enrollment'>
                    <img
                      className='tickImage_enrollment'
                      src={require(`../../assets/images/surveyModule/${pageData.shortCode}.png`)}
                      alt="Image for Survey"
                    />
                    <span className='accordianText_enrollment'>{pageData.name}</span>
                  </TableCell>
                  <TableCell className='schoolHeader_enrollment'>
                    <div className='pht_enrollment' name={pageData.shortCode} onClick={resetSelection}>Reset Enrollments</div>
                  </TableCell>
                </TableRow>
              </Table>
            </AccordionSummary>
            <AccordionDetails key={pageData._id}>
              <div className='mainTable'>
                <div className='firstHeader row'>
                  <div className='col1'></div>
                  <div className='col2'></div>
                  <div className='col3'>
                    {/* <span className=''> */}
                    {pageData.name == 'Elementary Survey' ?
                      < span className='ribbon1'>Enter Enrollment for Survey Grade</span> :
                      pageData.name == 'Middle School Survey' ?
                        < span className='ribbon2'>Enter Enrollment for Survey Grade</span> :
                        pageData.name == 'High School Survey' ?
                          < span className='ribbon3'>Enter Enrollment for Survey Grade</span> : ''}
                    {/* </span> */}
                  </div>
                  <div className='col4'></div>
                </div>

                <div className='secondHeader row'>
                  <div className='col1 tableHeaderTxt'>School Name</div>
                  <div className='col2 tableHeaderTxt'>School ID</div>
                  <div className='col3 row'>

                    {pageData.schoolEnrollData[0].enrollmentData.map((enrlheader, enrlheaderIndex) => (
                      <div className='equalCol tableHeaderTxt' key={enrlheaderIndex}>
                        {enrlheader.enrollmentName == '3rd' ? <>{enrlheader.enrollmentName.slice(0, -2)}<sup>rd</sup> </> : enrlheader.enrollmentName == 'NT' ? <>{enrlheader.enrollmentName}</> : <>{enrlheader.enrollmentName.slice(0, -2)}<sup>th</sup> </>}
                      </div>
                    ))}

                  </div>
                  <div className='col4'></div>
                </div>

                {pageData.schoolEnrollData.map((enrlData, enrlDataIndex) => (
                  <div className='tableData row' style={enrlDataIndex % 2 ? { background: "#eeeeee" } : { background: "#ffffff" }}>
                    <div className='col1 tableHeaderDataTxt'>{enrlData.name}</div>
                    <div className='col2 tableHeaderDataTxt'>{enrlData.ncesId ? enrlData.ncesId : enrlData.schoolId}</div>
                    <div className='col3 row' id={enrlData.schoolId} key={enrlData.schoolId}>
                      {enrlData.enrollmentData.map((enrlVal, enrlValIndex) => (
                        <div className='equalCol tableHeaderTxt' id={enrlData.schoolId + '-' + enrlVal.enrollmentId + '-' + enrlValIndex} key={enrlData.schoolId + '-' + enrlVal.enrollmentId + '-' + enrlValIndex}>
                          {/* <input
                            style={{ backgroundColor: '#ffffff' }}
                            autoComplete='off'
                            type="number"
                            value={enrlVal.value ? enrlVal.value : ''}
                            shortCode={pageData.shortCode}
                            ncesId={enrlData.ncesId}
                            enrollmentName={enrlVal.enrollmentName}
                            className='inputForTable_enrollment'
                            id={`outlined-basic_${enrlValIndex}`}
                            key = {enrlValIndex}
                            variant="outlined"
                            onChange={(e) =>
                              updateEnrollment(pageData._id, enrlData.schoolId, enrlVal.enrollmentId, e.target.value)
                            }
                          ></input> */}

                          <input
                            style={{ backgroundColor: '#ffffff' }}
                            autoComplete='off'
                            type="number"
                            value={enrlVal.value ? enrlVal.value : ''}
                            shortCode={pageData.shortCode}
                            ncesId={enrlData.ncesId}
                            enrollmentName={enrlVal.enrollmentName}
                            key={`outlined-basic_${enrlValIndex}`}
                            className='inputForTable_enrollment'
                            id={`outlined-basic_${enrlValIndex}`}
                            variant="outlined"
                            onChange={(e) =>
                              updateEnrollment(pageData._id, enrlData.schoolId, enrlVal.enrollmentId, e.target.value)
                            }
                            disabled={localStorage.getItem("academicyear") !== 'currentyear'}
                          />

                        </div>

                      ))}

                    </div>
                    <div className='col4'></div>
                  </div>
                ))}
              </div>

            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      {localStorage.getItem("academicyear") === 'currentyear' && (
        <div className='Button_enrollment'>
          {showSubmit && saveShow ? (
            <Button
              variant="contained"
              className='buttonText_enrollment'
              onClick={handleSave}
            >SAVE</Button>
          ) : null}

          {showSubmit && !saveShow ? (
            <Button
              variant="contained"
              className="buttonText_enrollment_save"
              onClick={handleFinish}
            >
              FINISH
            </Button>
          ) : null}
        </div>
      )}


    </>
  )
}


export default Enrollment;
